var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BigNumber } from "@ethersproject/bignumber";
import { useContext } from "react";
import { CHAINS_TO_ID, isSolanaVault, VaultAddressMap, VaultList, VaultVersionList, } from "../constants/constants";
import { isEVMChain } from "../utils/chains";
import { SubgraphDataContext } from "./subgraphDataContext";
var getVaultKey = function (vault) { return "vault_" + vault.replace(/-/g, ""); };
export var vaultGraphql = function (version, chain) {
    return VaultList.reduce(function (acc, vault) {
        var vaultAddress = VaultAddressMap[vault][version];
        if (!isSolanaVault(vault) &&
            (!vaultAddress || VaultAddressMap[vault].chainId !== CHAINS_TO_ID[chain])) {
            return acc;
        }
        if (isEVMChain(chain)) {
            vaultAddress = vaultAddress === null || vaultAddress === void 0 ? void 0 : vaultAddress.toLowerCase();
        }
        return (acc +
            (version === "v1"
                ? "\n          " + getVaultKey(vault) + ": vault(id: \"" + vaultAddress + "\" ){\n            id\n            name\n            symbol\n            totalBalance\n            totalPremiumEarned\n            totalWithdrawalFee\n            totalNotionalVolume\n            underlyingAsset\n            underlyingSymbol\n          }\n\n        "
                : "\n          " + getVaultKey(vault) + ": vault(id: \"" + vaultAddress + "\" ){\n            id\n            name\n            symbol\n            totalBalance\n            totalPremiumEarned\n            totalFeeCollected\n            totalNominalVolume\n            totalNotionalVolume\n            " + (version !== "earn" ? "underlyingAsset" : "") + "\n            " + (version !== "earn" ? "underlyingSymbol" : "") + "\n            " + (version === "earn" ? "principalOutstanding" : "") + "\n            " + (version === "earn" ? "numberOfHits" : "") + "\n            " + (version === "earn" ? "optionsTraded" : "") + "\n          }\n        "));
    }, "");
};
export var resolveVaultsSubgraphResponse = function (responses) {
    return Object.fromEntries(VaultVersionList.map(function (version) { return [
        version,
        Object.fromEntries(VaultList.map(function (vault) {
            var vaultData = responses[version]
                ? responses[version][getVaultKey(vault)]
                : undefined;
            return [
                vault,
                vaultData
                    ? __assign(__assign({}, vaultData), { totalBalance: BigNumber.from(vaultData.totalBalance) }) : undefined,
            ];
        })),
    ]; }));
};
export var useVaultsSubgraphData = function () {
    var contextData = useContext(SubgraphDataContext);
    return {
        data: contextData.vaultSubgraphData.vaults,
        loading: contextData.vaultSubgraphData.loading,
    };
};
//# sourceMappingURL=useVaultData.js.map